<template>
  <div>
    <div class="vx-row mb-4">
      <div class="vx-col md:w-1/2 w-full">
        <h2>{{ $t("product.Inventario") }}</h2>
      </div>
      <div class="vx-col md:w-1/2 w-full">
        <div class="text-right">
          <vs-button
            @click="setpopupNewDish(true)"
            color="primary"
            type="border"
            >{{ $t("product.NuevoProducto") }}</vs-button
          >
          <vs-popup
            :title="$t('product.NuevoProducto')"
            class="popup-w-900"
            :active.sync="popupNewDish"
          >
            <new-dish ref="newDishModal"></new-dish>
          </vs-popup>
          <router-link :to="{ name: 'dish-groups' }">
            <vs-button type="border" class="ml-2"> Ver categorias </vs-button>
          </router-link>
        </div>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <table-data-grid
          :data="itemsDataGrid"
          :dataColumns="dataColumns"
          link="dish"
        >
          <template v-slot:actions="slotProps">
            <div class="dropdown-button-container">
              <router-link
                :to="{
                  name: 'publicDish',
                  params: {
                    lang: language,
                    id: slotProps.item.id,
                    slug: slotProps.item.slug_restaurant,
                  },
                }"
                target="_blank"
                :disabled="isItemActive(slotProps.item.active)"
              >
                <vs-button
                  class="btnx"
                  type="filled"
                  color="primary"
                  :disabled="isItemActive(slotProps.item.active)"
                >
                  {{ $t("Ver") }}
                </vs-button>
              </router-link>
              <vs-dropdown vs-trigger-click>
                <vs-button
                  class="btn-drop"
                  type="filled"
                  icon="expand_more"
                ></vs-button>
                <vs-dropdown-menu>
                  <ul style="min-width: 12rem">
                    <li>
                      <span
                        @click="editDish(slotProps.item.id)"
                        class="cursor-pointer py-3 px-4 block text-primary hover:bg-primary hover:text-white w-full"
                      >
                        <feather-icon icon="EditIcon" svgClasses="w-4 h-4" />
                        <span class="ml-2">{{ $t("Editar") }}</span>
                      </span>
                    </li>

                    <vs-divider class="m-1" />
                    <li>
                      <span
                        @click="
                          deleteModalDishGroup(
                            slotProps.item.id,
                            slotProps.item.name
                          )
                        "
                        class="cursor-pointer py-3 px-4 block hover:bg-danger text-danger hover:text-white w-full"
                      >
                        <feather-icon icon="TrashIcon" svgClasses="w-4 h-4" />
                        <span class="ml-2">{{ $t("Eliminar") }}</span>
                      </span>
                    </li>
                  </ul>
                </vs-dropdown-menu>
              </vs-dropdown>
              <vs-popup
                :title="$t('product.EdicionProducto')"
                class="popup-w-900"
                v-if="openModal"
                :active.sync="popupEditDish"
              >
                <edit-dish :dish="dish" v-if="openModal" />
              </vs-popup>
            </div>
          </template>
          <template v-slot:active="slotProps">
            <feather-icon
              icon="CheckCircleIcon"
              svgClasses="w-5 h-5 text-success hover:text-black stroke-current"
              @click="deactiveModalDish(slotProps.item.id, slotProps.item.name)"
            />
          </template>
          <template v-slot:deactive="slotProps">
            <feather-icon
              icon="XCircleIcon"
              svgClasses="w-5 h-5 text-danger hover:text-black stroke-current"
              @click="activeModalDish(slotProps.item.id, slotProps.item.name)"
            />
          </template>
          <template v-slot:name="slotProps">
            <a
              target="_blank"
              :href="
                $router.resolve({
                  name: 'publicDish',
                  params: {
                    lang: language,
                    id: slotProps.item.id,
                    slug: slotProps.item.slug_restaurant,
                  },
                }).href
              "
              class="disabled hover:text-black"
              :disabled="isItemActive(slotProps.item.active) ? '' : disabled"
            >
              {{ slotProps.item.name }}
            </a>
          </template>
        </table-data-grid>
      </div>
    </div>
  </div>
</template>

<script>
import TableDataGrid from "../components/TableDataGrid";
import NewDish from "../components/Dishes/NewDish.vue";
import EditDish from "../components/Dishes/EditDish.vue";
import { mapActions, mapMutations, mapGetters } from "vuex";

export default {
  components: {
    TableDataGrid,
    NewDish,
    EditDish,
  },
  data() {
    return {
      dialog: false,
      dataColumns: [
        { dataField: "id", caption: "ID", visible: false },
        {
          caption: this.$t("Imagen"),
          dataType: "image",
          visible: true,
          width: 175,
        },
        {
          dataField: "active",
          caption: this.$t("Activo"),
          dataType: "slot",
          visible: true,
          width: 75,
        },
        {
          dataField: "itemName",
          caption: this.$t("Nombre"),
          dataType: "slot",
          visible: true,
          width: 400,
        },
        {
          dataField: "size",
          caption: this.$t("Tamanyo"),
          dataType: "text",
          visible: true,
          width: 150,
          class: "hidden lg:table-cell",
        },
        {
          dataField: "price",
          caption: this.$t("Precio"),
          dataType: "text",
          visible: true,
        },
        {
          dataField: "category",
          caption: this.$t("Categoria"),
          dataType: "text",
          visible: true,
          class: "hidden lg:table-cell",
        },
        {
          caption: this.$t("IdiomasTraducidos"),
          dataType: "text",
          visible: true,
          width: 150,
        },
        {
          caption: this.$t("Alergenos"),
          dataType: "text",
          visible: true,
          width: 400,
          class: "hidden xl:table-cell",
        },
        { caption: "Slug", dataType: "text", visible: false },
        {
          dataField: "name",
          caption: this.$t("Nombre"),
          dataType: "text",
          visible: false,
        },
      ],
      popupNewDish: false,
    };
  },
  created() {
    this.refreshDishes({ language: this.language });
  },
  computed: {
    ...mapGetters({
      languages: "getLanguages",
      itemsDishes: "getDishes",
      dish: "getDish",
      language: "getCurrentLanguage",
    }),
    popupEditDish: {
      get() {
        return this.$store.getters.getpopupEditDish;
      },
      set(val) {
        console.log("SET", val);
        this.$store.commit("setpopupEditDish", val);
      },
    },
    // eslint-disable-next-line vue/no-dupe-keys
    popupNewDish: {
      // eslint-disable-next-line object-shorthand
      set(val) {
        this.popupNewDish = val;
      },
    },
    openModal() {
      console.log(
        this.popupEditBanner === true && Object.keys(this.dish).length > 0
      );
      console.log("OPEN");
      if (this.popupEditDish === true && Object.keys(this.dish).length > 0) {
        return true;
      }
      return false;
    },
    itemsDataGrid() {
      const items = this.itemsDishes;
      const results = [];
      const placeholder = process.env.VUE_APP_IMAGE_PLACEHOLDER;
      const aux = this;

      items.forEach(function (item, index) {
        const dishAllergens = [];
        if (item.allergens) {
          for (let i = 0; i < item.allergens.length; i++) {
            dishAllergens.push(
              `<span class="w-8 inline-block text-center mr-2" ><img src="${item.allergens[i].image_path}" title="${item.allergens[i].name}" ></span>`
            );
          }
        }

        const langs = new Array();
        const auxLangs = eval(items[index].available_languages);

        if (auxLangs) {
          auxLangs.forEach(function (ln) {
            langs.push(aux.languages[ln]);
          });
        }

        results[index] = {
          id: items[index].id,
          image: `<img src="${placeholder}" style="width: 175px;" class="product-img" >`,
          active: "deactive",
          itemName: "name",
          size: items[index].size,
          price: `${items[index].price}€`,
          category: item.category.name,
          languages: langs.join(", "),
          allergens: dishAllergens.join(" "),
          slug_restaurant: items[index].slug_restaurant,
          name: items[index].name,
        };
        if (items[index].images[0]) {
          results[
            index
          ].image = `<img src="${items[index].images[0].path}" style="width: 175px;" class="product-img" >`;
        }
        if (items[index].active === 1) {
          results[index].active = "active";
        }
      }, items);

      return results;
    },
  },
  methods: {
    setpopupNewDish(val) {
      this.popupNewDish = val;
      this.$refs.newDishModal.resetForm();
    },
    ...mapActions({
      refreshDishes: "refreshDishes",
      activeDish: "activeDish",
      deactiveDish: "deactiveDish",
      deleteDish: "deleteDish",
      deleteDishGroup: "deleteDishGroup",
      getDish: "getDish",
    }),
    ...mapMutations({
      setDish: "setItemDish",
      loading: "loading",
    }),
    isItemActive(active) {
      if (active === "active") {
        return false;
      } else {
        return true;
      }
    },
    editDish(id) {
      this.setDish({});
      this.getDish({ id, language: this.language, isEditDish: false });
      console.log("[EDIT]");
      this.popupEditDish = true;
    },

    deleteModalDishGroup(id, name) {
      const aux = this;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: this.$t("product.EliminarProducto"),
        text: this.$t("product.EliminarConfirm", { nombre: name }),
        acceptText: this.$t("Aceptar"),
        cancelText: this.$t("Cancelar"),
        accept() {
          aux.deleteDish(id);
        },
      });
    },
    activeModalDish(id, name) {
      const aux = this;
      this.$vs.dialog({
        type: "confirm",
        color: "success",
        title: this.$t("product.ActivarProducto"),
        text: this.$t("product.ActivarConfirm", { nombre: name }),
        acceptText: this.$t("Aceptar"),
        cancelText: this.$t("Cancelar"),
        accept() {
          aux.activeDish(id);
        },
      });
    },
    deactiveModalDish(id, name) {
      const aux = this;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: this.$t("product.DesactivarProducto"),
        text: this.$t("product.DesactivarConfirm", { nombre: name }),
        acceptText: this.$t("Aceptar"),
        cancelText: this.$t("Cancelar"),
        accept() {
          aux.deactiveDish(id);
        },
      });
    },
  },
};
</script>
